import { Button, Form, InputNumber, Modal, notification, Spin, Switch } from "antd";
import React, { useEffect, useState } from "react";
import BinDTO from "src/models/BinDTO";
import BinSettingsDTO from "src/models/BinSettingsDTO";
import  BinApiService  from 'src/api/BinApiService';

interface UserVisisbleSystemSettingsProps{
    open: boolean;
    onClose: () => void;
    bin: BinDTO | undefined;
}

const UserVisibleSystemSettings : React.FC<UserVisisbleSystemSettingsProps> = ({ open, onClose, bin }) => {

    const [form] = Form.useForm<BinSettingsDTO>();
    const [loading, setLoading ] = useState<boolean>(false);
    
    const onFinish = async (values: BinSettingsDTO) =>{
        setLoading(true);
        try{

            values.binID = bin?.id!;   
            const result = await BinApiService.setBinSettingsOverrides(bin?.deviceId ?? "", values);
            notification.success({ message:"Bin settings uploaded" })

        }catch(err){
            console.log("Error uploading bin settings", err);
            notification.error({
              message: err.detail,
              description: err.errorDetails.detail,
            });
        }
        setLoading(false);
        onClose();
    }
    
    useEffect(() => {
        if (bin && bin.binSettings && !form.isFieldsTouched()) {
            form.setFieldsValue(bin.binSettings as any);
        } else {
            console.error("bin or bin.binSettings is null");
        }
    }, [bin]);

    return(
        <Modal
        title="System Settings"
        open={open}
        onCancel={() => {
            onClose();
        }}
        okButtonProps={{ style: { display: 'none' } }}
        width='35%'
        >
            <Form
            scrollToFirstError={true}
            onFinish={onFinish}
            autoComplete="off"
            form={form}
            initialValues={bin?.binSettings ?? {} as BinSettingsDTO}
            style={{ height:'100%', maxHeight:'600px', overflowY: 'auto' }}
            >
                <Form.Item hidden name={'keepFansOff'}/>
                <Form.Item hidden name={'keepCompressorOff'} />
                <Form.Item hidden name={'repeatPreDry'} />
                <Form.Item hidden name={'plenumHighTempF'} />
                <Form.Item hidden name={'commonCloseTimePeriodSeconds'} />
                <Form.Item hidden name={'hotSpotThresholdTemperatureF'} />
                <Form.Item hidden name={'weatherConditionsMinMc'} />
                <Form.Item hidden name={'weatherConditionsMaxMc'} />
                <Form.Item hidden name={'weatherConditionsMinTemperatureF'} />
                <Form.Item hidden name={'weatherConditionsMaxTemperatureF'} />
                <Form.Item hidden name={'kpLayerTimeAdjustment'} />
                <Form.Item hidden name={'kiLayerTimeAdjustment'} />
                <Form.Item hidden name={'kdLayerTimeAdjustment'} />
                <Form.Item hidden name={'rhSensorDataSource'} />
                <Form.Item hidden name={'tempSensorDataSource'} />
                <Form.Item hidden name={'grainHeightAtCenterStacksFt'} />
                <Form.Item hidden name={'grainHeightAtPerimeterStacksFt'} />
                <Form.Item hidden name={'useRHForFanControl'} />

                {
                    (bin?.fans?.length ?? 0) > 0 && 
                    <>
                        <Form.Item
                        label="Fan Stagger Seconds"
                        extra="The amount of seconds each fan startup is staggered by, default 1 second"
                        key={'fanStaggerSeconds'}
                        name={'fanStaggerSeconds'}
                        rules={[{ required: false }]}>
                            <InputNumber min={0} style={{ width: '75px' }} />
                        </Form.Item>
                    </>
                }
                
                {
                    (bin?.temperatureCables?.length ?? 0) > 0 &&
                    <Form.Item
                    name={'tempCableOffsetF'}
                    label={'Temperature Cable Offset (°F)'}
                    >
                        <InputNumber style={{ width: '96px' }} />
                    </Form.Item>    
                }
                
                {
                    ( (bin?.moistureCables_RF?.length ?? 0) > 0 || (bin?.moistureCables?.length ?? 0) > 0 || 
                        (bin?.opiMoistureCables?.length ?? 0) > 0 || (bin?.binSenseMoistureCables?.length ?? 0) > 0) &&
                    <Form.Item
                    name={'moistureCableTempOffsetF'}
                    label={'Moisture Cable Temperature Offset (°F)'}
                    >
                        <InputNumber style={{ width: '96px' }} />
                    </Form.Item> 
                }

                {
                    ( (bin?.moistureCables_RF?.length ?? 0) > 0 || (bin?.moistureCables?.length ?? 0) > 0 || 
                        (bin?.opiMoistureCables?.length ?? 0) > 0 || (bin?.binSenseMoistureCables?.length ?? 0) > 0) &&
                    <Form.Item
                    name={'moistureCableMoistureOffsetPercent'}
                    label={'Moisture Cable Moisture Offset (%)'}
                    >
                        <InputNumber style={{ width: '96px' }} />
                    </Form.Item> 
                }

                {
                    (bin?.devices?.fanBoards?.length ?? 0) > 0 &&
                    <>
                        <Form.Item
                        name={'incomingAirTempOffsetF'}
                        label={'Incoming Air Temperature Offset (°F)'}
                        >
                            <InputNumber style={{ width: '96px' }} />
                        </Form.Item>

                        <Form.Item
                        name={'incomingAirMoistureOffsetPercent'}
                        label={'Incoming Air Moisture Offset (%)'}
                        >
                            <InputNumber style={{ width: '96px' }} />
                        </Form.Item>
                    </>
                }

                <Form.Item>
                    <Button
                    type="primary"
                    htmlType="submit"
                    style={{ float: "right" }}
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>

            <Modal
            open={loading}
            centered
            closable={false}
            footer={null}
            width={100}
            style={{ textAlign: 'center' }}
            >
                <Spin size="large"/>
            </Modal>
        </Modal>
    )
}

export default UserVisibleSystemSettings;